import React from 'react';
import WorkoutsList from 'fit/pages/strength/WorkoutsList';

const WorkoutsListRoute =()=>{
    return (<WorkoutsList getToday={false}/>);
}

export default WorkoutsListRoute;